// About.js

import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import PageAnimation from '../components/animations/PageAnimation';
import SEO from '../components/SEO';

// These styles create the colored content box.
// They can be customized to match the branding of Matax Express Ltd.
const pageStyles = {
    textColor: '#1A4314',      // A deep, trustworthy green
    backgroundColor: '#F7F6F2', // A clean, off-white background
};

// Content is now sourced from environment variables
const content = {
    title: process.env.REACT_APP_ABOUT_TITLE || "About Us",
    slogan: process.env.REACT_APP_ABOUT_SLOGAN || "Your trusted partner.",
    // Split the paragraphs string by '||' to create an array
    paragraphs: (process.env.REACT_APP_ABOUT_PARAGRAPHS || '').split('||'),
};

function AboutPage() {
    return (
        <PageAnimation>
            <SEO
                title="About Us | Matax Express"
                description="Learn about Matax Express - Toronto's reliable wholesale grocery partner. Family-owned business committed to quality produce and exceptional service."
                keywords="about Matax Express, Toronto wholesale grocery company, produce supplier story, wholesale food distributor"
                url="https://mataxexpress.ca/about"
            />
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Typography
                    variant="h3"
                    component="h1"
                    align="center"
                    sx={{ fontWeight: 'bold', mb: 4, color: pageStyles.textColor }}
                >
                    {content.title}
                </Typography>

                <Paper
                    elevation={0}
                    sx={{
                        backgroundColor: pageStyles.backgroundColor,
                        color: pageStyles.textColor,
                        p: { xs: 4, md: 6 }, // Responsive padding
                        borderRadius: 3,
                    }}
                >
                    <Box sx={{ maxWidth: '800px', mx: 'auto' }}>
                        {content.paragraphs && content.paragraphs.map((para, index) => (
                            <Typography
                                key={index}
                                variant="body1"
                                paragraph
                                sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}
                            >
                                {para}
                            </Typography>
                        ))}

                        <Typography
                            variant="h5"
                            component="p"
                            align="center"
                            sx={{
                                my: 5,
                                fontStyle: 'italic',
                                fontWeight: 500,
                                lineHeight: 1.6,
                                px: 2,
                            }}
                        >
                            "{content.slogan}"
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </PageAnimation>
    );
}

export default AboutPage;